module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Mute-476773e21f7f1899d15029cbe0d73692.svg";